var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0835 7.125H14.2502M11.0835 9.89583H13.4585",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4585 2.375H5.54183C3.3557 2.375 1.5835 4.14721 1.5835 6.33333V12.6667C1.5835 14.8528 3.3557 16.625 5.54183 16.625H13.4585C15.6446 16.625 17.4168 14.8528 17.4168 12.6667V6.33333C17.4168 4.14721 15.6446 2.375 13.4585 2.375Z",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9585 12.6665C4.91483 10.6232 8.4805 10.4894 9.50016 12.6665M8.31266 7.12484C8.31266 7.54476 8.14585 7.94749 7.84891 8.24442C7.55198 8.54136 7.14926 8.70817 6.72933 8.70817C6.3094 8.70817 5.90668 8.54136 5.60974 8.24442C5.31281 7.94749 5.146 7.54476 5.146 7.12484C5.146 6.70491 5.31281 6.30218 5.60974 6.00525C5.90668 5.70832 6.3094 5.5415 6.72933 5.5415C7.14926 5.5415 7.55198 5.70832 7.84891 6.00525C8.14585 6.30218 8.31266 6.70491 8.31266 7.12484Z",
    stroke: "white",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.262e58afc8c63749af9b29b8c6958632.svg";
export { ForwardRef as ReactComponent };